import svg4everybody from 'svg4everybody';

export default function() {
    svg4everybody();
}


// Ajouter un span avant les images floaté dans le o-text pour éviter une cascade d'imamges lorsqu'il n'y a pas assez de texte

document.addEventListener("DOMContentLoaded", function() {
    // Sélectionner toutes les images avec les classes spécifiées dans un .o-text
    var images = document.querySelectorAll('.is-imported .o-text img.alignleft, .is-imported .o-text img.alignright');

    images.forEach(function(image) {
      // Créer un nouvel élément <span> avec la classe .floated-img
      var openingSpan = document.createElement('span');
      openingSpan.className = 'floated-img';

      // Insérer le <span> ouvrant avant l'image
      image.parentNode.insertBefore(openingSpan, image);
    });
  });

document.addEventListener('DOMContentLoaded', function() {
    // Fonction pour mettre à jour la valeur en fonction de la largeur du navigateur
    function updateDataScrollOffset() {
        var htmlElement = document.documentElement;
        var newOffset;

        // Déterminez la largeur de la fenêtre
        var windowWidth = window.innerWidth;

        // Réglez la valeur en fonction de la largeur de la fenêtre
        if (windowWidth < 768) { // Si la largeur est inférieure à 768 pixels (mobile)
            newOffset = '-100';
        } else if (windowWidth < 1024) { // Si la largeur est inférieure à 1024 pixels (tablettes)
            newOffset = '-120';
        } else {
            newOffset = '-200'; // Par défaut pour les écrans plus larges
        }

        // Mettez à jour l'attribut data-scroll-default-offset
        if (htmlElement.hasAttribute('data-scroll-default-offset')) {
            htmlElement.setAttribute('data-scroll-default-offset', newOffset);
        }
    }

    // Mettez à jour la valeur lors du chargement initial
     setTimeout(() => {
        updateDataScrollOffset();
    }, 300);
    

    // Écoutez les changements de taille de fenêtre pour mettre à jour la valeur en temps réel
    window.addEventListener('resize', updateDataScrollOffset);
});

function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000)); // 1 day
        // date.setTime(date.getTime() + (2 * 60 * 1000)); // 2 minutes
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

document.addEventListener('DOMContentLoaded', function() {
    var closeButtons = document.querySelectorAll('.js-overlay-close-cookie');
    closeButtons.forEach(function(button) {
        button.addEventListener('click', function() {
            setCookie('modalpopup', 'shown', 14); // Cookie expires in 1 day
        });
    });
});

